import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router';

const publicRoutes: RouteRecordRaw[] = [
    {
        path: '/contracts/:contract/recipients/:recipient/sign',
        props: true,
        name: 'SignView',
        component: () => import('@/views/SignView.vue'),
    },
    {
        path: '/contracts/:contract/reviewers/:reviewer/review',
        props: true,
        name: 'ReviewView',
        component: () => import('@/views/ReviewView.vue'),
    },
    {
        path: '/contracts/:contract/reviewers/:reviewer/view',
        props: true,
        name: 'ReviewReadOnlyView',
        component: () => import('@/views/ReviewReadOnlyView.vue'),
    },
    {
        path: '/not-found',
        name: 'NotFound',
        component: () => import('@/views/NotFound.vue'),
    },
    {
        path: '/:pathMatch(.*)*',
        redirect: { name: 'NotFound' },
    },
];

const mfeRoutes: RouteRecordRaw[] = [
    {
        path: '/',
        name: 'TemplatesList',
        component: () => import('@/views/TemplatesList.vue'),
    },
    {
        path: '/new',
        name: 'NewTemplate',
        component: () => import('@/views/NewTemplate.vue'),
    },
    {
        path: '/templates/:templateId',
        props: true,
        name: 'TemplateView',
        component: () => import('@/views/TemplateView.vue'),
    },
    {
        path: '/reviews/:contract',
        props: true,
        name: 'EditContractView',
        component: () => import('@/views/EditContractView.vue'),
    },
    {
        path: '/not-found',
        name: 'NotFound',
        component: () => import('@/views/NotFoundMfe.vue'),
    },
    {
        path: '/:pathMatch(.*)*',
        redirect: { name: 'NotFound' },
    },
];

const devRoutes: RouteRecordRaw[] = [
    {
        path: '/',
        name: 'TemplatesList',
        component: () => import('@/views/TemplatesList.vue'),
    },
    {
        path: '/new',
        name: 'NewTemplate',
        component: () => import('@/views/NewTemplate.vue'),
    },
    {
        path: '/templates/:templateId',
        props: true,
        name: 'TemplateView',
        component: () => import('@/views/TemplateView.vue'),
    },
    {
        path: '/contracts/:contract/recipients/:recipient/sign',
        name: 'SignView',
        props: true,
        component: () => import('@/views/SignView.vue'),
    },
    {
        path: '/contracts/:contract/reviewers/:reviewer/review',
        props: true,
        name: 'ReviewView',
        component: () => import('@/views/ReviewView.vue'),
    },
    {
        path: '/contracts/:contract/reviewers/:reviewer/view',
        props: true,
        name: 'ReviewReadOnlyView',
        component: () => import('@/views/ReviewReadOnlyView.vue'),
    },
    {
        path: '/reviews/:contract',
        props: true,
        name: 'EditContractView',
        component: () => import('@/views/EditContractView.vue'),
    },
    {
        path: '/not-found',
        name: 'NotFound',
        component: () => import('@/views/NotFound.vue'),
    },
    {
        path: '/:pathMatch(.*)*',
        redirect: { name: 'NotFound' },
    },
];

const getRouter = (
    basename: string = import.meta.env.BASE_URL,
    routes: RouteRecordRaw[] = import.meta.env.DEV ? devRoutes : publicRoutes,
) => {
    return createRouter({
        history: createWebHistory(basename),
        routes,
    });
};

export {
    publicRoutes,
    mfeRoutes,
    getRouter,
};
